import { useNavigate } from 'react-router-dom';

export default function CTASection() {
  const navigate = useNavigate();

  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-900 via-primary-800 to-primary-900"></div>
      
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-saudi-gold-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 font-cairo">
          ابدأ رحلتك التعليمية اليوم
        </h2>
        <p className="text-xl text-white/90 mb-10 font-tajawal leading-relaxed">
          لا تفوت فرصة الالتحاق بالجامعة المناسبة لك. استكشف جميع الخيارات المتاحة واتخذ القرار الصحيح لمستقبلك
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => navigate('/opportunities')}
            className="bg-white text-primary-700 px-10 py-5 rounded-full font-tajawal font-bold text-xl hover:bg-gray-50 transition-all inline-flex items-center gap-3 cursor-pointer whitespace-nowrap shadow-2xl hover:scale-105"
          >
            <span>استكشف الجامعات</span>
            <i className="ri-arrow-left-line"></i>
          </button>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-8 mt-16 pt-16 border-t border-white/20">
          <div>
            <div className="text-4xl font-bold text-white mb-2 font-cairo">50+</div>
            <div className="text-white/70 font-tajawal">جامعة</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-white mb-2 font-cairo">200+</div>
            <div className="text-white/70 font-tajawal">تخصص</div>
          </div>
          <div>
            <div className="text-4xl font-bold text-white mb-2 font-cairo">1000+</div>
            <div className="text-white/70 font-tajawal">طالب</div>
          </div>
        </div>
      </div>
    </section>
  );
}
